/**
 * Created by A665445 on 13/04/2017.
 */
import {Route} from '@angular/router';
import {InternalComponent} from './internal.component';

export const INTERNAL_ROUTE: Route = {
    path: 'interne',
    component: InternalComponent,
    data: {
        authorities: [],
        pageTitle: 'internal.title.connexion'
    }
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/internal/internal.route.ts